import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    makeStyles
} from '@material-ui/core';
import React, { useContext } from 'react';
import { PropTypes } from 'prop-types';
import LanguageContext from '../../../contexts/languageContext';
import { CloseIcon } from '../Images/Icons';
const styles = makeStyles({
    dialogRoot: (props) => ({
        direction: props.rtl ? 'rtl' : 'ltr',
        textAlign: props.rtl ? 'right' : 'left',
        fontFamily: 'mainFont'
    }),
    container: {
        paddingTop: '12px',
        position: 'relative'
    },
    alertText: {
        color: 'black'
    },
    closeIconWrapper: {
        // background: 'red',
        position: 'absolute',
        marginInlineStart: '5px',
        marginBottom: '12px',
        '& svg': {
            cursor: 'pointer'
        }
    },
    buttonWrapper: {
        flexDirection: 'row-reverse',
        justifyContent: 'flex-start'
    },
    delButton: {
        background: '#fff',
        boxShadow: 'none',
        color: '#ee384e',
        borderColor: '#ee384e',
        fontFamily: 'inherit',
        fontSize: '16px',
        minWidth: '60px',
        '&:hover': {
            background: '#ee384e',
            color: '#fff'
        }
    },
    primaryConfirmButton: {
        background: '#fff',
        boxShadow: 'none',
        color: '#416ce1',
        borderColor: '#416ce1',
        fontFamily: 'inherit',
        fontSize: '16px',
        minWidth: '60px',
        '&:hover': {
            background: '#416ce1',
            color: '#fff'
        }
    },
    cancelButton: {
        color: '#989ea3',
        fontFamily: 'inherit',
        fontSize: '16px',
        padding: '7px 10px',
        minWidth: '60px',
        '&:hover': {
            background: '#989ea3',
            color: '#fff'
        }
    },
    primaryCancelButton: {
        color: '#416ce1',
        fontFamily: 'inherit',
        fontSize: '16px',
        padding: '7px 10px',
        minWidth: '60px',
        '&:hover': {
            background: '#416ce1',
            color: '#fff'
        }
    }
});
const AlertDialog = (props) => {
    const { lang } = useContext(LanguageContext);
    const classes = styles({ rtl: lang === 'fa' });
    const {
        handleClose,
        open,
        title,
        alertText,
        confirmText,
        cancelText,
        handleAction,
        primaryCancelButton = false,
        primaryConfirmButton = false,
        handleClickOutSide
    } = props;
    return (
        <Dialog
            classes={{ root: classes.dialogRoot, paper: classes.container }}
            onClose={handleClickOutSide ? handleClickOutSide : handleClose}
            open={open ? open : false}
            data-testid="alertDialog"
        >
            <div className={classes.closeIconWrapper}>
                <CloseIcon onClick={handleClickOutSide ? handleClickOutSide : handleClose} />
            </div>
            {title && <DialogTitle data-testid="title">{title}</DialogTitle>}
            <DialogContent>
                <DialogContentText className={classes.alertText}>{alertText}</DialogContentText>
            </DialogContent>
            <DialogActions className={classes.buttonWrapper}>
                {confirmText && (
                    <Button
                        className={
                            primaryConfirmButton ? classes.primaryConfirmButton : classes.delButton
                        }
                        // variant="contained"
                        // color="primary"
                        onClick={handleAction}
                        data-testid="action"
                    >
                        {confirmText}
                    </Button>
                )}
                <Button
                    className={
                        primaryCancelButton ? classes.primaryCancelButton : classes.cancelButton
                    }
                    // color="primary"
                    onClick={handleClose}
                    data-testid="close"
                >
                    {cancelText}
                </Button>
            </DialogActions>
        </Dialog>
    );
};
AlertDialog.propTypes = {
    open: PropTypes.bool,
    title: PropTypes.string,
    alertText: PropTypes.string,
    confirmText: PropTypes.string,
    cancelText: PropTypes.string,
    handleClose: PropTypes.func,
    handleAction: PropTypes.func,
    primaryCancelButton: PropTypes.bool,
    primaryConfirmButton: PropTypes.bool,
    handleClickOutSide: PropTypes.func
};
export default AlertDialog;
